import {createTheme, responsiveFontSizes, ThemeOptions, useTheme} from "@mui/material/styles";
import {BreakfastDiningOutlined, ExpandMore} from "@mui/icons-material";
import React, { useEffect, useState } from "react";
import {ThemeProvider} from '@mui/material/styles';
import { Daybook } from "./generated/graphql";
import { useDaybookContext } from "./contexts/Daybook/DayBookContext";

/*
palette: {
    background: {
        paper: '#555555',
    default: '#444444'
    },
    primary: {
        main:''
    },
    secondary: {
        main:'#E7F1F3'
    },
    text: {
        primary: 'rgba(255,255,255,0.87)',
            secondary: 'rgba(255,255,255,0.6)'
    }
},
*/

export const TableThemeProvider = ({children})=>{
    const theme = useTheme();
    const [theTheme,setTheTheme] = useState(theme);
    useEffect(()=>{
        const newTheme:ThemeOptions = {
            components: {
                MuiAutocomplete: {
                    styleOverrides: {
                        inputRoot: {
                            fontSize: '0.75rem'
                        },
                        listbox: {
                            fontSize: '0.75rem'
                        },
                        loading: {
                            fontSize: '0.75rem'
                        },
                        noOptions: {
                            fontSize: '0.75rem'
                        }
                    }
                },
                MuiInput: {
                    styleOverrides: {
                        root: {
                            fontSize: '0.75rem'
                        }
                    }
                }
            }
        };
        setTheTheme(responsiveFontSizes(createTheme(theme,newTheme)));
    },[theme]);
    return <ThemeProvider theme={theTheme}>
    {children}
    </ThemeProvider>;
}


export const DaybookThemeProvider = ({children}) => {
    const daybook = useDaybookContext();
    const [theme,setTheme] = React.useState(generateTheme(daybook));
    React.useEffect(()=>{
        setTheme(generateTheme(daybook));
    },[daybook]);
return <ThemeProvider theme={theme}>
{children}
</ThemeProvider>;
}

function generateTheme(daybook:Daybook) {
    let primaryColour = '#000000';
    switch(daybook?.theme) {
        case 'nightbook':
            primaryColour = '#303030';
        break;
        case 'daybook':
            //main:'#1565a0'
            //main: '#137CBD'
            primaryColour = '#137CBD';
//            '#1565a0';
            //primaryColour = '';
        break;
    }
    const theme = {
        typography: {
            htmlFontSize: 16,
            fontSize: 12,
            fontFamily: ['Roboto', 'Arial', 'Sans-serif', 'Sans'].join(','),
            allVariants: {
                fontFamily: ['Roboto', 'Arial', 'Sans-serif', 'Sans'].join(',')
            },
            rowHeight: "24px"
        },
        palette: {
            primary: {
                main: primaryColour
            }
        },
        //palette: {
            //background: {
                // disabled nightbook
                //paper: "rgba(240,240,240,1)"
            //},
            //primary: {
                //main: '#303030'
                //main:'#1565a0'
    //            main: '#137CBD'
            //},
        //},
    /*    palette: {
            mode:'dark',
            background: {
                paper: '#555555',
                default: '#333333'
            },
            primary: {
              main:'#1565a0'
            },
            secondary: {
                main:'#E7F1F3'
            },
            text: {
                primary: 'rgba(255,255,255,0.87)',
                secondary: 'rgba(255,255,255,0.6)'
            }
        },*/
        components: {
            MuiTextField: {
                defaultProps: {
                    size: 'small',
                    margin: 'dense',
                    variant: 'filled'
                },
            },
            MuiSelect: {
                defaultProps: {
                    size: 'small',
                    margin:'dense',
                    variant: 'filled'
                }
            },
            MuiTooltip: {
                styleOverrides: {
                    tooltip: {
                        fontSize: "1rem"
                    }
                }
            },
            MuiTabs: {
                styleOverrides: {
                    root:({theme})=> ({
                        backgroundColor: theme.palette.background.default
                    })
                }
            },
            MuiSvgIcon: {
                styleOverrides: {
                    root: ()=>({
                        zIndex:1
                    })
                }
            },
            MuiAccordion: {
                defaultProps: {
                    disableGutters: true
                }
            },
            MuiAccordionSummary: {
                defaultProps: {
                    color: (theme) => theme.palette.primary,
                    expandIcon: <ExpandMore/>,
                    sx: (theme) => ({
                        backgroundColor: theme.palette.primary.light,
                        color: '#FFFFFF',
                        '& .MuiAccordionSummary-expandIconWrapper': {color: '#FFFFFF'},
                        fontWeight: theme.typography.fontWeightRegular,
                        fontFamily: theme.typography.fontFamily
                    })
                },
                styleOverrides: {
                    content: {
                        fontWeight: 400
                    }
                }
            },
            FieldTable: {
                styleOverrides: {
                    root: ({theme})=> ({
                        color: theme?.palette.text.primary,
                        border: '1px solid '+theme.palette.divider,
                        backgroundColor: theme.palette.divider,
                        fontFamily: theme?.typography?.body1.fontFamily,
                        fontSize: theme.typography.body2.fontSize,
                        fontWeight: theme.typography.body1.fontWeight,
                        "&.field-table-no-children > .field-table__row:nth-child(2n) > .field-table__cell": {
                            backgroundColor: theme.palette.background.default
                        },
                        "&.field-table-no-children > .field-table__row:nth-child(2n+1) > .field-table__cell": {
                            //backgroundColor: theme.palette.background.paper
                            backgroundColor: theme.palette.backgroundOffWhite
                        },
                        " > .field-table__child" :{
                            marginLeft:'24px',
                            backgroundColor: theme.palette.common.white,
                            borderLeft: "1px solid "+theme.palette.divider
                        },
                        "&.field-table-has-children > .field-table__row:nth-child(4n) > .field-table__cell ": {
                            backgroundColor: theme.palette.backgroundOffWhite
    //                        backgroundColor:   theme.palette.background.paper
                        },
                        "&.field-table-has-children > .field-table__row:nth-child(4n+1) > .field-table__cell ": {
                            backgroundColor: theme.palette.backgroundOffWhite
    //                        backgroundColor:   theme.palette.background.paper
                        }
                    }),
                    header: ({theme})=>({
                        color: theme.palette.text.primary,
                        backgroundColor: theme.palette.backgroundOffWhite,
    //                    backgroundColor: theme.palette.background.paper,
                        borderBottom: '1px solid '+theme.palette.divider,
                        position: "sticky",
                        top: 0,
                        zIndex:2,
                        fontSize: '0.6rem'
                    }),
                    cell: ({ownerState,theme})=>({}
                    ),
                    cellError:({theme})=> (
                       {
                            border: '1px dashed '+theme.palette.error.light+' !important'
                     }),
    
                    titleTooltip:({theme})=>(
                        {
                            display: "flex",
                            alignItems: "center",
                            borderBottom: "1px dashed "+theme.palette.primary.light
                        }
                    ),
                    noData:({theme})=>(
                        {
                            height:"50px",
                            gridColumn:"1/-1",
                            justifyContent:"center",
                            alignItems:"center",
                            display:"flex",
                            backgroundColor:theme.palette.background.default
                        }
                    ),
                    footer:({theme})=>(
                        {
                            backgroundColor: theme.palette.backgroundOffWhite,
    //                        backgroundColor: theme.palette.background.paper,
                            "&.sticky": {
                                position: "sticky",
                                backgroundColor: "#e0e0e0"
                            },
                            zIndex: 1,
                            bottom: 0,
                            display: "flex",
                            padding: theme.spacing(1)
                        }
                    )
                }
            },
            MonthControl: {
                styleOverrides: {
                    root: ({theme}) => ({
                        display: "inline-flex",
                        maxWidth: "800px",
                        '& > *': {
                            flex: '0 0 auto',
                            marginLeft: theme.spacing(1),
                            marginRight: theme.spacing(1)
                        }
                    })
                }
            },
            Daybook: {
                defaultProps: {
                    logoCollapsed:'/images/logo-uncle-collapsed.png',
                    logo:'/images/logo-uncle-full-white.png',
                    toolbarBackground:'linear-gradient(90deg, #202020, #203030)',
                    sidebarBackground:'linear-gradient(90deg,#303030,#202020)'
                }
            },
            Toolbar: {
                styleOverrides: {
                   title: ({theme})=>({
                        color: theme.palette.primary.contrastText
                    }),
                    root: ({theme}) => ({
                        display: "inline-flex",
                        maxWidth: "800px",
                        '& > *': {
                            flex: '0 0 auto',
                            marginLeft: theme.spacing(1),
                            marginRight: theme.spacing(1)
                        }
                    })
                }
            },
            WaitPanel: {
                variants: [{
                        props:{variant:'panel'},
                        style:{
                            display:"flex",
                            alignItems:"center",
                            justifyContent:"center",
                            position:"absolute",
                            left:0,
                            right:0,
                            top:0,
                            bottom:0
                        }
                    }]
            },
            HollywoodLayout: {
                styleOverrides: {
                    root:({theme})=>({
                        backgroundColor: theme.palette.background.default
                    })
                }
            },
            PanelBookings: {
                styleOverrides: {
                    grid:({theme})=>({
                        boxSizing: 'border-box',
                        display: 'grid',
                        fontFamily: theme.typography.body1.fontFamily,
                        fontSize: theme.typography.body2.fontSize,
                        gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr',
                        '> .panel-booking-table__row': {
                            display: 'contents'
                        },
                        '> .panel-booking-table__header__row': {
                            display: 'contents',
                            '> .panel-booking-table__header__options': {
                                gridColumn: '1 / 4',
                                display: 'flex',
                                justifyContent: "space-between",
                                alignItems: "center"
                            }
                        },
                        '> .panel-booking-table__header__row > *': {
                            position: 'sticky',
                            top: 0,
                            zIndex: 2,
                            backgroundColor: '#FFF',
                            // theme.palette.backgroundOffWhite, - this colour can have an alpha channel
    //                        backgroundColor: theme.palette.background.paper,
                            height: "100%",
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontWeight: theme.typography.fontWeightBold
                        },
                        ' .panel-booking-table__cell': {
                            borderLeft: '1px solid '+theme.palette.divider,
                            borderTop: '1px solid '+theme.palette.divider,
                            minHeight: '85px',
                            textAlign: 'center',
                            padding: theme.spacing(2),
                            display: 'flex',
                            boxSizing: "border-box",
                            flexDirection: 'column',
                            justifyContent: 'space-between'
                        },
                        '.panel-booking-table__3row': {
                            padding: theme.spacing(1)+' '+theme.spacing(2),
                            borderTop: '1px solid '+theme.palette.divider,
                            height: "100%",
                            display: "flex",
                            boxSizing: 'border-box',
                            flexDirection: "column",
                            justifyContent: "space-between"
                        }
                    })
                }
            },
            CampaignChanges: {
                styleOverrides: {
                   container: ({theme})=>({
                       color: theme.palette.primary.text,
                       height: "100%",
                       width: "100%",
                       fontFamily: theme.typography.fontFamily,
                       fontSize: theme.typography.fontSize,
                       fontWeight: theme.typography.fontWeightMedium
                   }),
                   table: ({theme})=>({
                        width: "100%",
                        overflowY: "auto",
                        borderCollapse: "collapse",
                        "& tr": {
                            height: "24px"
                        },
                       "& th": {
                           color: theme.palette.text.primary,
                            textAlign: "left"
                       },
                        "& .active td": {
                            backgroundColor: theme.palette.primary.main,
                            color: theme.palette.primary.contrastText,
                            "a": {
                                color: theme.palette.primary.contrastText
                            }
                        },
                       "& .change-header": {
                            position: "sticky",
                            top: theme.typography.rowHeight,
                            zIndex: 1,
                            backgroundColor: theme.palette.backgroundOffWhite,
    //                        backgroundColor: theme.palette.background.paper,
                            color: theme.palette.text.primary
                        },
                        "& .change-header td": {
                           fontWeight: "bold"
                        },
                        "& thead": {
                            position: "sticky",
                            backgroundColor: theme.palette.background.default,
                            top: 0
                        }
                   })
               }
            }
        }
    }; 
    console.log('THEME',theme);
    const themeA = createTheme(theme as any);

    const themeOverrides: any = {};
    switch(daybook?.theme) {
        case 'nightbook':
            themeOverrides.palette = {
                backgroundOffWhite: themeA.palette.grey["A200"]
                /*primary: {
                    main: '#303030'
                }*/
            };
            themeOverrides.components = {
                MuiAccordionSummary: {
                    defaultProps: {
                        color: (theme)=>theme.palette.primary
                    },
                    sx: (theme) => ({
                        backgroundColor: theme.palette.primary.light,
                        color: '#FFFFFF',
                        '& .MuiAccordionSummary-expandIconWrapper': {color: '#FFFFFF'},
                        fontWeight: theme.typography.fontWeightBold,
                        fontFamily: theme.typography.fontFamily
                    })
                },
                Daybook: {
                    defaultProps: {
                        logoCollapsed:'/images/logo-uncle-collapsed.png',
                        logo:'/images/logo-uncle-full-white.png',
                        toolbarBackground:'linear-gradient(90deg, #202020, #203030)',
                        sidebarBackground:'linear-gradient(90deg,#303030,#202020)'
                    }
                },
            };
            break;
        case 'daybook':
            themeOverrides.palette = {
                //primary: {
                    //main:'#000000'
                //main:'#1565a0'
                //main: '#137CBD'
                  //main:'#1565a0',
                //},
                backgroundOffWhite: 'rgba(0,0,0,0)',                
//                backgroundOffWhite: 'rgba(240,240,240,1)',
                background: {
                    // disabled nightbook
                    paper: "rgba(240,240,240,1)"
                }
            };
            themeOverrides.components = {
                MuiAccordionSummary: {
                    defaultProps: {
                        sx: (theme) => ({
                            backgroundColor: theme.palette.primary.dark,
                            color: '#FFFFFF',
                            '& .MuiAccordionSummary-expandIconWrapper': {color: '#FFFFFF'},
                            fontWeight: theme.typography.fontWeightBold,
                            fontFamily: theme.typography.fontFamily
                        })                    
                    }
                },
                Daybook: {
                    defaultProps: {
                        logoCollapsed:'/images/logo-bh-collapsed.png',
                        logo:'/images/logo-bh-full-2021.png',
                        toolbarBackground:'linear-gradient(90deg, #124577, #0f2c48)',
                        sidebarBackground:'linear-gradient(90deg,#0f2c48,#124577)'
                    }
                }
            };
        break;
    }
    const themeB = createTheme(themeA,themeOverrides);
  return responsiveFontSizes(themeB);
}